import React, { useContext, useState, useEffect, useRef } from "react";
import { store } from "../../Store";
import { Link, useLocation } from "react-router-dom";

import { NavbarBrand } from "../components/NavbarBrand";
import { NavbarNav } from "./components/NavbarNav";
import { DropdownResponsive } from "./components/dropdownResponsivePublicHeader/DropdownResponsive";
import { SkeletonHeader } from "./components/SkeletonHeader";

import useIsMobile from "../../../js/utilities/useIsMobile";
import { useNetworkStatus } from "../../../hooks/use-network-status";
import { useTranslations } from "../../../hooks/use-translations";
import { usePublicHeaderDropdown } from "../../../hooks/header/usePublicHeaderDropdown";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Tools } from "./components/Tool";
import { useLanguage } from "../../../hooks/use-language";
import { HeaderActions } from "../components/header-actions";
import { PublicLangButton } from "./components/PublicLangButton";
/**
 * Componente del header sin login
 * @returns {JSX.Element} - PublicHeader
 */
export const PublicHeader = () => {
	const lang = useLanguage();
	const textosInterfaz = useTranslations({ section: "header", lang: lang, array: true });

	const globalState = useContext(store);
	const { dispatch, state } = globalState;

	const [isLoading, setIsLoading] = useState(true);

	const isMobile = useIsMobile();
	const internetConnection = useNetworkStatus();

	const publicHeaderDropdown = usePublicHeaderDropdown();
	const dropdownButtonRef = useRef(null);

	const location = useLocation();

	/*Asigna el botón que abre el dropdown del header publico o sin login */
	useEffect(() => {
		if (dropdownButtonRef.current) {
			globalState.dispatch({
				type: "CHANGE",
				path: "publicHeaderDropdown.triggerButtonRef",
				value: dropdownButtonRef,
			});
		}
	}, [dropdownButtonRef.current]);

	useEffect(() => {
		if (state?.datosHeader) {
			setIsLoading(false);
		}
	}, [state?.datosHeader]);

	return (
		<>
			{isLoading ? (
				<SkeletonHeader />
			) : (
				<div className="public-header">
					<nav className="h-100 d-flex" role="navigation">
						<div className="content-logo">
							<Link
								to={"/que-es"}
								className="logo"
							>
								<div className="img-public-logo">
									<img
										alt={textosInterfaz?.logo_alt || "MakeMake página de inicio"}
										src={'/img/logos/logo-sombra.png'}
									/>
								</div>
							</Link>
						</div>

						{!isMobile && (
							<div className="primary-nav mr-auto">
								<NavbarNav textosInterfaz={textosInterfaz} lang={lang} />
							</div>
						)}
						{!isMobile && location.pathname !== '/institucional/formulario' && (
							<div className="secondary-nav">
								<Tools textosInterfaz={textosInterfaz} />
							</div>
						)}

						{isMobile && (
							<ul className="header-controls ml-auto">
								<li>
									<Link
										to={'/contacto'}
										className={`focusable-red ml-1 buttonv2 button-primary px-2 py-3 p-sm-3 btn-secondary-nav`}
									>
										{textosInterfaz?.pedir_demo || 'Pide un demo'}

									</Link>
								</li>
								<li>
									<PublicLangButton />
								</li>
								<li>
									<button
										ref={dropdownButtonRef}
										onClick={() => {
											if (internetConnection.online) {
												publicHeaderDropdown.setVisible(
													!publicHeaderDropdown?.state?.visible
												);
											}
										}}
										className={`focusable-red icon-button icon-responsive`}
										aria-expanded={!!publicHeaderDropdown?.state?.visible}
										aria-controls="menu-responsive"
										aria-haspopup="menu"
									>
										<Icon icon="material-symbols:menu-rounded" width={40} />
									</button>
								</li>
							</ul>
						)}
					</nav>

					{isMobile && <DropdownResponsive textosInterfaz={textosInterfaz} />}

					{!isMobile &&
						<HeaderActions textosInterfaz={textosInterfaz} />
					}
				</div>
			)}
		</>
	);
};
